import { Box, Pagination, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material'

interface Props {
  currentPage: number
  totalPages: number
  totalCount: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange?: (pageSize: number) => void
  isLoading?: boolean
  showPageSizeSelector?: boolean
  pageSizeOptions?: number[]
}

export const BlogPaginationAdvanced = ({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  isLoading = false,
  showPageSizeSelector = false,
  pageSizeOptions = [6, 12, 24, 48],
}: Props) => {
  const startItem = (currentPage - 1) * pageSize + 1
  const endItem = Math.min(currentPage * pageSize, totalCount)

  if (totalPages <= 1 && !showPageSizeSelector) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        mt: 4,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Typography variant="body2" color="text.secondary">
          Hiển thị {startItem}-{endItem} trong tổng {totalCount} bài viết
        </Typography>

        {showPageSizeSelector && onPageSizeChange && (
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Số bài/trang</InputLabel>
            <Select
              value={pageSize}
              label="Số bài/trang"
              onChange={(e) => onPageSizeChange(e.target.value as number)}
              disabled={isLoading}
            >
              {pageSizeOptions.map((size) => (
                <MenuItem key={size} value={size}>
                  {size} bài viết
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(_, page) => onPageChange(page)}
          disabled={isLoading}
          color="primary"
          shape="rounded"
          showFirstButton
          showLastButton
          siblingCount={1}
          boundaryCount={1}
          sx={{
            '& .MuiPagination-ul': {
              justifyContent: 'center',
            },
          }}
        />
      )}
    </Box>
  )
}
